// extracted by mini-css-extract-plugin
module.exports = {"example":"TaxonomyConfiguration-module__example___PA7d_"};